import React from 'react';
import propTypes from 'prop-types';

function Details({
  degree,
  email,
  field,
  grad_year: gradYear,
  name,
  resumeLink,
  university,
}) {
  function detailsUI(text, value) {
    return (
      <p className="profile-sidebar__small">
        {`${text}: ${value || 'N/A'}`}
      </p>
    );
  }

  return (
    <div className="profile-sidebar__details">
      <h1 className="profile-sidebar__name">
        {name}
      </h1>
      <p className="profile-sidebar__small">
        {email}
      </p>
      {detailsUI('College', university)}
      {detailsUI('Degree', degree)}
      {detailsUI('Field', field)}
      {detailsUI('Grad Year', gradYear)}

      <a
        href={resumeLink}
        onClick={() => window.trackGaEvent(
          'ProfilePage',
          'Link',
          'Resume',
        )}
        target="_blank"
        rel="noopener noreferrer"
        className="profile-sidebar__resume"
      >
        {'View Resume >'}
      </a>
    </div>
  );
}

Details.propTypes = {
  name: propTypes.string,
  email: propTypes.string,
  university: propTypes.string,
  grad_year: propTypes.oneOfType([propTypes.number, propTypes.string]),
};

export default Details;
